import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Switch, Tooltip, Grid } from '@mui/material';
import ReusableTable from "components/table/table";
import config from "config/config";
import Context from "context/context";
import Button from '@mui/material/Button';
import { Modal, Card, CardMedia, CardContent, Typography, IconButton,Box } from '@mui/material';
import savedtemplate from "../../../../assets/images/savedtemplate.jpg";
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
// import { toast } from '../../../../../node_modules/react-toastify/dist/index';
import { toast, ToastContainer } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Checkbox } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';



const AddGoals = () => {
  const [showAssignedView, setShowAssignedView] = useState(false);
  const [nonAssignedEmployees, setNonAssignedEmployees] = useState([]);
  const [count, setCount] = useState(0);
  const [offset, setOffset] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const limit = 10; // Pagination limit
  const { dispatch } = useContext(Context);
  const [assignedEmployees, setAssignedEmployees] = useState([]);
  const [templates, setTemplates] = useState([]); // Templates state
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [templateData, setTemplateData] = useState(null); 
  const [templateDetails, setTemplateDetails] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [selectedKpi, setSelectedKpi] = useState(null);
const [selectedIds, setSelectedIds] = useState([]);
const [assignedGoals, setAssignedGoals] = useState([]); 
const [isModalOpenView, setIsModalOpenView] = useState(false);
const handleEditClick = (kpi) => {
  setSelectedKpi(kpi);
  setIsEditModalOpen(true);
};

const handleCheckboxChangeunassign = (id) => {
    setSelectedIds((prevSelectedIds) =>
      prevSelectedIds.includes(id)
        ? prevSelectedIds.filter((itemId) => itemId !== id) // Remove if already selected
        : [...prevSelectedIds, id] // Add if not selected
    );
  };
const handleSaveWeightage = () => {
  // Update the weightage in the templateDetails
  if (!selectedKpi?.weightage || selectedKpi.weightage === "") {
    toast.error("Weightage is required and must be a valid number between 1 and 100.");
    return;
  }

  // Ensure weightage is within the valid range
  if (selectedKpi.weightage < 1 || selectedKpi.weightage > 100) {
    toast.error("Weightage must be a number between 1 and 100.");
    return;
  }
  const updatedDetails = templateDetails.kpiKraDetails.map((kpi) =>
    kpi.kpiKraDetailsId === selectedKpi.kpiKraDetailsId
      ? { ...kpi, weightage: selectedKpi.weightage }
      : kpi
  );

  // Update state with modified details
  setTemplateDetails({ ...templateDetails, kpiKraDetails: updatedDetails });

  setIsEditModalOpen(false);
};


  const toggleComponent = () => {
    setShowAssignedView((prevState) => {
      const newState = !prevState;
      if (newState) {
        fetchAssignedEmployees(); // Fetch data when switching to assigned view
      }
      return newState;
    });
  };

  const handleBack = () => {
    setTemplateDetails(null)
  };

  const fetchNonAssignedEmployees = useCallback(async (search = "") => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      const query = encodeURIComponent(
        JSON.stringify({
          offset: (offset - 1) * limit,
          limit: limit,
          searchValue: search,
        })
      );
      const url = `${config.host}/panel/pms/allNonAssignedEmployees?query=${query}`;

      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`HTTP error! status: ${response.status}, ${errorData.message || ""}`);
        dispatch({ type: "SET_LOADING", payload: false });
      }

      const data = await response.json();
    //   if (data.status === "Ok" && Array.isArray(data.data.allNonAssignedEmployees)) {
    //     const formattedData = data.data.allNonAssignedEmployees.map((employee, index) => ({
    //       id: employee.employeeId,
    //       index: index + 1 + (offset - 1) * limit, // S.No
    //       employeeCode: employee.employeeCode,
    //       firstName: employee.firstName,
    //       role: employee.role,
    //     }));
    //     setNonAssignedEmployees(formattedData);
    //     setCount(data.data.allNonAssignedEmployees.length);
    //     dispatch({ type: "SET_LOADING", payload: false });
    //   }
    //    else {
    //     console.error("Unexpected data format:", data);
    //     setNonAssignedEmployees([]);
    //     dispatch({ type: "SET_LOADING", payload: false });
    //   }
    // } catch (error) {
    //   console.error("Error fetching Non-Assigned Employees:", error);
    //   toast.error(error.message); 
    //   dispatch({ type: "SET_LOADING", payload: false });
    // }
    if (data.status === "Ok") {
      // Check if there's an error in the response even if the status is Ok
      if (data.data?.error) {
        toast.error(data.data.error); // Show error toast
      } else if (Array.isArray(data.data.allNonAssignedEmployees)) {
        // If no error and data is valid
        const formattedData = data.data.allNonAssignedEmployees.map((employee, index) => ({
          id: employee.employeeId,
          index: index + 1 + (offset - 1) * limit, // S.No
          employeeCode: employee.employeeCode,
          firstName: employee.firstName,
          role: employee.role,
        }));
        setNonAssignedEmployees(formattedData);
        setCount(data.data.allNonAssignedEmployees.length);
      } else {
        console.error("Unexpected data format:", data);
        setNonAssignedEmployees([]);
      }
    }
  } catch (error) {
    console.error("Error fetching Non-Assigned Employees:", error.message);
    toast.error(error.message); // Show error toast for unexpected errors
  } finally {
    dispatch({ type: "SET_LOADING", payload: false });
  }
  }, [offset, limit]);

  const fetchAssignedEmployees = useCallback(async (search = "") => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      const query = encodeURIComponent(
        JSON.stringify({
          offset: (offset - 1) * limit,
          limit: limit,
          searchValue: search,
        })
      );
      const url = `${config.host}/panel/pms/allAssignedEmployees?query=${query}`;

      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`HTTP error! status: ${response.status}, ${errorData.message || ""}`);
        dispatch({ type: "SET_LOADING", payload: false });
      }

      const data = await response.json();
    //   if (data.status === "Ok" && Array.isArray(data.data.allAssignedEmployees)) {
    //     const formattedDataassigned = data.data.allAssignedEmployees.map((employee, index) => ({
    //       id: employee.employeeId,
    //       index: index + 1 + (offset - 1) * limit, // S.No
    //       employeeCode: employee.employeeCode,
    //       firstName: employee.firstName,
    //       role: employee.role,
    //       employeeAssessmentsId:employee.employeeAssessmentsId,
    //     }));
    //     setAssignedEmployees(formattedDataassigned);
    //     setCount(data.data.allNonAssignedEmployees.length);
    //     dispatch({ type: "SET_LOADING", payload: false });
    //   } else {
    //     console.error("Unexpected data format:", data);
    //     setAssignedEmployees([]);
    //     dispatch({ type: "SET_LOADING", payload: false });
    //   }
    // } catch (error) {
    //   console.error("Error fetching Assigned Employees:", error);
    //   dispatch({ type: "SET_LOADING", payload: false });
    // }

    if (data.status === "Ok") {
      if (data.data?.error) {
        // Handle error message when status is "Ok"
        toast.error(data.data.error);
        setAssignedEmployees([]);
        setCount(0);
        dispatch({ type: "SET_LOADING", payload: false });
        return;
      }

      if (Array.isArray(data.data.allAssignedEmployees)) {
        // Process and set assigned employees
        const formattedDataAssigned = data.data.allAssignedEmployees.map((employee, index) => ({
          id: employee.employeeId,
          index: index + 1 + (offset - 1) * limit, // S.No
          employeeCode: employee.employeeCode,
          firstName: employee.firstName,
          role: employee.role,
          employeeAssessmentsId: employee.employeeAssessmentsId,
        }));

        setAssignedEmployees(formattedDataAssigned);
        setCount(data.data.allAssignedEmployees.length);
      } else {
        // Handle unexpected data format
        console.error("Unexpected data format:", data);
        toast.error("Unexpected data format!");
        setAssignedEmployees([]);
        setCount(0);
      }
    } else {
      // Handle other statuses
      console.error("Unexpected status:", data.status);
      toast.error("Failed to fetch assigned employees!");
      setAssignedEmployees([]);
      setCount(0);
    }

    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    // Handle fetch errors
    console.error("Error fetching Assigned Employees:", error);
    toast.error("Error fetching data. Please try again.");
    setAssignedEmployees([]);
    setCount(0);
    dispatch({ type: "SET_LOADING", payload: false });
  }
  }, [offset, limit]);

  const handleUnassignEmployee = async () => {

    if (!selectedIds || selectedIds.length === 0) {
      toast.error("Please select at least one item to unassign.");
      return;
    }
    dispatch({ type: "SET_LOADING", payload: true });
  
    try {
      // Call the Unassign Goals API
      const response = await fetch(`${config.host}/panel/pms/deleteAssignedGoals`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          employeeAssessmentsId:selectedIds, // Pass the employeeAssessmentsId array
        }),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to unassign goals");
      }
  
      const data = await response.json();
  
      if (data.status === "Ok") {
        toast.success(`Successfully unassigned ${data.data.deleted} goals.`);
        console.log("Unassigned Employee Assessment IDs:", selectedIds);
  
        // Refresh or fetch updated data here if needed
        fetchAssignedEmployees(); // Replace with your function to fetch updated data
        fetchNonAssignedEmployees();
      } else {
        toast.error("Failed to unassign goals.");
      }
    } catch (error) {
      console.error("Error unassigning goals:", error);
      toast.error(`Error: ${error.message}`);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };
  

  const handleViewEmployee = async (employeeAssessmentsId) => {
    try {
      const response = await fetch(`${config.host}/panel/pms/assignedGoals?employeeAssessmentsId=${employeeAssessmentsId}`, {
        method: "GET",
        credentials: "include", // Ensure that the credentials are sent with the request if needed
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch assigned goals");
      }

      const data = await response.json();

      if (data.status === "Ok" && Array.isArray(data.data)) {
        // Flatten the kpiDetails array across all data items
        const formattedDataView = data.data.flatMap((employee, index) => 
          employee.kpiDetails.map((kpi, kpiIndex) => ({
            id: kpi.kpiKraDetailsId,
            index: kpiIndex + 1, // Serial number for each KPI
            kpiName: kpi.kpiName,
            weightage: kpi.weightage,
            kraCategory:kpi.kraCategory,
            templateName: employee.templateName,
          }))
        );
        setAssignedGoals(formattedDataView); // Set assigned goals to state
        console.log(tableData)
        toast.success("Assigned goals!");
        
        dispatch({ type: "SET_LOADING", payload: false });
      }

     else {
        toast.error("Failed to fetch assigned goals.");
      }
    } catch (error) {
      console.error("Error fetching assigned goals:", error);
      toast.error(`Error: ${error.message}`);
    }
  };

  useEffect(() => {
    if (assignedGoals.length > 0) {
        console.log(assignedGoals)
      setIsModalOpenView(true); // Open the modal only after assignedGoals has data
    }
  }, [assignedGoals]);
  const handleCheckboxChange = (employeeId) => {
    setSelectedEmployees((prevSelected) =>
      prevSelected.includes(employeeId)
        ? prevSelected.filter((id) => id !== employeeId) // Deselect
        : [...prevSelected, employeeId] // Select
    );
    
  };

  useEffect(() => {
    fetchNonAssignedEmployees(searchValue);
  }, [fetchNonAssignedEmployees, searchValue, offset]);

  const tableDataModal = assignedGoals.map((employee) => [
    employee.index, // S.No
    employee.kraCategory,
    employee.kpiName,
    employee.weightage,
    
  ]);

  // Prepare data for the table
  const tableData = nonAssignedEmployees.map((employee) => [
    employee.index, // S.No
    
    employee.employeeCode,
    employee.firstName,
    employee.role,
   
    <input
      type="checkbox"
      checked={selectedEmployees.includes(employee.id)}
      onChange={() => handleCheckboxChange(employee.id)}
    />,
  ]);

  const tableDataAssigned = assignedEmployees.map((employee) => [
    employee.index, // S.No
    employee.employeeCode,
    employee.firstName,
    employee.role,
   
    <VisibilityIcon
    style={{
        cursor: "pointer",
        color: "#0070E9",
        fontSize: "1.5rem", // Adjust size if needed
      }}
      onClick={() => handleViewEmployee(employee.employeeAssessmentsId)} // Define this handler for the eye icon
    />,
   
    <Checkbox
      checked={selectedIds.includes(employee.employeeAssessmentsId)} // Check state
      onChange={() => handleCheckboxChangeunassign(employee.employeeAssessmentsId)} // Update state on change
      color="primary"
    />,

  ]);

  const fetchTemplates = useCallback(async (search = "") => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {

        const query = encodeURIComponent(
            JSON.stringify({
              offset: (offset - 1) * limit,
              limit: limit,
              searchValue: search,
            })
          );
        
      const response = await fetch(`${config.host}/panel/pms/allTemplates?query=${query}`, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
      if (data.status === "Ok") {
        setTemplates(data.data.templatesData);
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        console.error("Failed to fetch templates");
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      dispatch({ type: "SET_LOADING", payload: false });
    }
  }, []);

  useEffect(() => {
    fetchNonAssignedEmployees(searchValue);
  }, [fetchNonAssignedEmployees, searchValue, offset]);

  // Open Modal
  const handleopenModal = () => {
    if (selectedEmployees.length === 0) {
        toast.error("Please select at least one employee.");
        return;
      }
    fetchTemplates();
    setIsModalOpen(true);
  };

  // Close Modal
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const handleTemplateClick = async (template) => {
    dispatch({ type: "SET_LOADING", payload: true });
    setIsModalOpen(false);
    try {
      // Prepare the query parameters
      const query = encodeURIComponent(
        JSON.stringify({
          offset: (offset - 1) * limit, // Adjust the offset for pagination
          limit: limit,
          searchValue: "", // Use the search value
        })
      );
  
      // Construct the URL with query parameters
      const url = `${config.host}/panel/pms/editKpiWeightage?assessmentTemplateId=${template.assessmentTemplateId}&query=${query}`;
  
      // Make the API request
      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      // Check for a successful response
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error fetching template: ${errorData.message || "Unknown error"}`);
      }
  
      // Parse the response data
      const data = await response.json();
      if (data.status === "Ok") {
        const fetchedTemplate = data.data.templateData[0];
        setTemplateDetails(fetchedTemplate); // Store fetched template data
        // setIsTemplateOpen(true); // Uncomment to open template display modal if needed
      } else {
        console.error("Failed to fetch template");
      }
    } catch (error) {
      console.error("Error fetching template details:", error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };
  const handleDeleteTemplate = (templateId) => {
    console.log("Delete Template ID:", templateId);
  };

  const handleAssignGoals = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    // Replace with actual values from state or props
   
    const assessmentTemplateId = templateDetails?.assessmentTemplateId;
    // const kpiKraDetailsIds = [
    //   { kpiKraId: "082527bb-4258-449c-87a5-ffffb641056e", weightage: 20 },
    //   { kpiKraId: "1008a805-271e-44f9-97e1-5687b9967a65", weightage: 60 },
    //   { kpiKraId: "151dd2bb-aebf-4759-a1aa-d7340ade4204", weightage: 10 },
    // ];
    const kpiKraDetailsIds = (templateDetails?.kpiKraDetails || []).map((kpi) => ({
        kpiKraId: kpi.kpiKraDetailsId,
        weightage: Number(kpi.weightage) || 0,
      }));

    // Calculate total weightage
    const totalWeightage = kpiKraDetailsIds.reduce(
        (sum, item) => sum + Number(item.weightage), // Convert weightage to a number
        0
      );

    // Validate weightage
    if (totalWeightage !== 100) {
        toast.error(
        `Total weightage must be 100. Current total is ${totalWeightage}. Please adjust the values.`
      );
      dispatch({ type: "SET_LOADING", payload: false });
      return;
    }

    // Call API if validation passes
    try {
      const response = await fetch(`${config.host}/panel/pms/assignGoals`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          employeeIds:selectedEmployees,
          assessmentTemplateId,
          kpiKraDetailsIds,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to assign goals");
        dispatch({ type: "SET_LOADING", payload: false });
      }

      const data = await response.json();
      if (data.status === "Ok") {
        toast.success("Goals assigned successfully!");
        console.log("Employee Assessment IDs:", data.data.employeeAssessmenstsIds);
        dispatch({ type: "SET_LOADING", payload: false });
        setSelectedEmployees([])
        setTemplateDetails(null)
        fetchNonAssignedEmployees();

      } else {
        toast.error("Failed to assign goals.");
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (error) {
      console.error("Error assigning goals:", error);
      toast.error(`Error: ${error.message}`);
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const closeModalView = () => {
    setIsModalOpenView(false);
    setAssignedGoals([]); // Clear goals when closing the modal
  };

  // Render Templates as Cards
  const renderTemplates = () => (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', padding: '20px' }}>
      {templates.map((template) => (
        <Card
          key={template.assessmentTemplateId}
          className="card-style"
          style={{ width: '200px', height: '250px', position: 'relative', cursor: 'pointer', boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)", borderRadius: "10px" }}
          onClick={() => handleTemplateClick(template)}
        >
         
         <CardMedia
                  component="img"
                  height="200"
                  image={savedtemplate}
                  alt="Saved Template"
                />
          <CardContent>
            <Typography variant="h6">{template.templateName}</Typography>
          </CardContent>
        </Card>
      ))}
    </div>
  );

    const formattedTemplateData = (templateDetails?.kpiKraDetails || []).map((kpi, index) => [
        index + 1, // S.No
        kpi.kraCategory || "N/A", // Assuming kraCategory could be a field in each KPI
        kpi.kpiName,
        kpi.role ?? "N/A",
        <>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <span style={{ whiteSpace: 'nowrap' }}>{kpi.weightage ?? "N/A"}</span>
  <Tooltip title="Edit Weightage">
    <EditIcon
      style={{
        cursor: "pointer",
      }}
      onClick={() => handleEditClick(kpi)}
    />
  </Tooltip>
</div>
  </>,
       
        // kpi.isActive ? (
        //   <img style={{ height: "20px" }} src={check} alt="Active" />
        // ) : (
        //   <img style={{ height: "20px" }} src={cross} alt="Inactive" />
        // ),
        // <Tooltip title="Select KPI">
        //   <Checkbox
        //     checked={selectedKpiIds.includes(kpi.kpiKraDetailsId)}
        //     onChange={() => handleCheckboxChange(kpi.kpiKraDetailsId)}
        //     color="primary"
        //   />
        // </Tooltip>,
    ]);

    return (
        <div className="add-goals-container">

{!templateDetails && (
  <div className="toggle-container">
    <Tooltip
      title={
        <span>
          Toggle to switch to view <br />
          goal assigned employees.
        </span>
      }
      arrow
    >
      <div className="toggle-wrapper">
        <Switch
          style={{ color: "gray" }}
          checked={showAssignedView}
          onChange={toggleComponent}
        />
        <span className={`toggle-label ${showAssignedView ? "enabled" : ""}`}>
          {showAssignedView
            ? "Assigned Employee View Enabled"
            : "Switch to View Assigned Employee"}
        </span>
      </div>
    </Tooltip>
  </div>
)}

        <div style={{ marginTop: "20px" }}>


        
            

            {templateDetails ? (
    <div className="template-display-section">
        <Button
            variant="contained"
            color="primary"
            onClick={handleBack}
            style={{ marginBottom: "5px" ,marginTop:"0" }}
        >
            Back
        </Button>
        <div style={{ padding: '20px', textAlign: 'center' }}>
        
        <ReusableTable
            title={<div className="leavemanageHeading">KRA/KPI LIST</div>}
            create={
            <Button className="AddKrabutton" onClick={handleAssignGoals}>
                Assign Goal
            </Button>
            }
            data={formattedTemplateData}
            count={formattedTemplateData.length}
            heading={["S.No", "KRA", "KPI Name", "Role", "Weightage"]}
            setSearchValue={setSearchValue}
            offset={offset}
            setOffset={setOffset}
            limit="25"
        />
        </div>
    </div>
) : (
  <>
    {showAssignedView ? (
      <div>
        <ReusableTable
          title={<div className="leavemanageHeading">Goal Assigned Employees</div>}
          
          create={
            tableDataAssigned.length > 0 && (
                <Button className="AddKrabutton" onClick={handleUnassignEmployee}>
                Unassign
              </Button>
            )
          }
          data={tableDataAssigned}
          count={count}
          offset={offset}
          setOffset={setOffset}
          limit={limit}
          setSearchValue={setSearchValue}
          heading={["S.No", "Employee Code", "Name", "Role", "View Goal","Select"]}
          placeholder="Search Employees..."
        />
      </div>
    ) : (
      <div>
        <ReusableTable
          title={<div className="leavemanageHeading">Goal Non-Assigned Employees</div>}
          create={
            tableData.length > 0 && (
              <Button className="AddKrabutton" onClick={handleopenModal}>
                Select Template
              </Button>
            )
          }
          searchBar={tableData} 
          data={tableData}
          count={count}
          offset={offset}
          setOffset={setOffset}
          limit={limit}
          setSearchValue={(value) => setSearchValue(value ? value.trim() : '')}
          heading={["S.No", "Employee Code", "Name", "Role", "Select"]}
          placeholder="Search Employees..."
        />
      </div>
    )}
  </>
)}
      </div>
      <Modal open={isModalOpen} onClose={closeModal}>
  <Box className="assign-modal-box">
    {/* Close Icon */}
    <div className="assign-close-icon" onClick={closeModal}>
      &times; {/* Close icon */}
    </div>

    {/* Modal Heading */}
    <Typography className="leavemanageHeadingcopy">Select a Template</Typography>
    
    {/* Cards Container */}
    <div className="assign-card-container">
      {templates.map((template) => (
        <Card
          className="assign-card-style"
          key={template.assessmentTemplateId}
          onClick={() => handleTemplateClick(template)}
        >
          <CardMedia
            component="img"
            className="assign-card-media"
            height="100"
            image={savedtemplate} // Replace with actual image path
            alt="Template"
          />
          <CardContent className="assign-card-content">
          <Tooltip title={template.templateName} arrow>
          <Typography variant="h6" className="assign-template-name">
            {template.templateName}
          </Typography>
        </Tooltip>
          </CardContent>
        </Card>
      ))}
    </div>

    {/* Close Button */}
    <button className="assign-close-button" onClick={closeModal}>
      Close
    </button>
  </Box>
</Modal>

<Modal
  open={isEditModalOpen}
  onClose={() => setIsEditModalOpen(false)}
  aria-labelledby="edit-weightage-modal"
  aria-describedby="edit-weightage-description"
>
  <div className="editmodal-container">
    <h3 className="editmodal-title">Edit Weightage</h3>

    {/* Read-only KRA field */}
    <TextField
      label="KRA"
      value={selectedKpi?.kraCategory || ""}
      InputProps={{
        readOnly: true,
      }}
      fullWidth
      margin="normal"
      className="editmodal-input"
    />

    {/* Read-only KPI field */}
    <TextField
      label="KPI"
      value={selectedKpi?.kpiName || ""}
      InputProps={{
        readOnly: true,
      }}
      fullWidth
      margin="normal"
      className="editmodal-input"
    />

    {/* Editable Weightage field */}
    <TextField
  label="Weightage"
  value={selectedKpi?.weightage || ""}
  onChange={(e) => {
    const inputValue = e.target.value;

    // Allow empty input to support clearing the field
    if (inputValue === "") {
      setSelectedKpi({ ...selectedKpi, weightage: "" });
      return;
    }

    // Parse the input as a number
    const value = Number(inputValue);

    // Ensure the value is within 1 to 100
    if (value >= 1 && value <= 100) {
      setSelectedKpi({ ...selectedKpi, weightage: value });
    }
  }}
  type="number"
  fullWidth
  margin="normal"
  className="editmodal-input"
/>

    {/* Buttons */}
    <div className="editmodal-button">
      <Button
        variant="contained"
        color="primary"
        onClick={handleSaveWeightage}
        className="editmodal-Savebutton"
      >
        Save
      </Button>
      <Button
        variant="outlined"
        onClick={() => setIsEditModalOpen(false)}
        className="editmodal-Cancelbutton"
      >
        Cancel
      </Button>
    </div>
  </div>
</Modal>
<Modal open={isModalOpenView} onClose={closeModalView}>
  <Box className="view-modal-box" sx={{ position: 'relative', padding: '20px' }}>
    {/* Close icon at the top right */}
    <CloseIcon 
  onClick={closeModalView} 
  sx={{
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer',
    fontSize: '20px',
    zIndex: 1000,
  }}
/>
    
    {/* Modal content */}
    <div >
      <ReusableTable
        title={<div className="leavemanageHeading">{`Template: ${assignedGoals.length > 0 ? assignedGoals[0].templateName : "KRA/KPI LIST"}`}</div>}
        data={tableDataModal}
        count={count}
        offset={offset}
        setOffset={setOffset}
        limit={limit}
        setSearchValue={setSearchValue}
        heading={["S.No", "KRA", "KPI", "Weightage"]}
      />
    </div>

    {/* <div style={{ position: 'relative', bottom: '10px', right: '20px' }}>
      <button 
        onClick={closeModalView} 
        style={{
          backgroundColor: '#007bff',
          color: '#fff',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        Close
      </button>
    </div> */}
    
    {/* Close button at the bottom right */}
   
  </Box>
</Modal>
    </div>
  );
};

export default AddGoals;
